// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'

// Selectors
import grids$ from './grids'
import selectedJobAndGrid$ from 'hfty-soil-jobs/src/selectors/selectedJobAndGrid'

// Constants
import { PROP_ID } from 'hfty-model-grid/src/constants'

export default createSelector([
  grids$,
  selectedJobAndGrid$,
], function (grids, selectedJob) {
  return _filter(grids, { job: selectedJob[PROP_ID] })
})
